import {Patient} from 'gabi-api-ts/v2/patient/query/patient_query';
import {PropsWithChildren} from 'react';
import styled from 'styled-components';

import {HealthReportNavigation} from '@/components/business/analytics/health-report/health-report-navigation';
import {HealthReportSidebar} from '@/components/business/analytics/health-report/health-report-sidebar';
import {HealthReportDashboardTypeEnum} from '@/enum/health-report-dashboard-type-enum';
import {transformPatient} from '@/model/transformers/transform-patient';

type HealthReportWrapperProps = PropsWithChildren & {
    patientId: string,
    patientData?: Patient | null,
    activeDashboard: HealthReportDashboardTypeEnum,
};

const HealthReportWrapper = ({patientId, patientData, activeDashboard, children}: HealthReportWrapperProps) => {
    // const patientContext = useMemo(
    //     () => PatientContextService.getPatientContext(patientData),
    //     [patientData]
    // );

    return (
        <StyledWrapper className="health-report-wrapper">
            <HealthReportSidebar
                patient={patientData ? transformPatient(patientData) : null}
            />

            <div className="health-report-widgets-wrapper">
                <div className="health-report-header">
                    <HealthReportNavigation
                        activeDashboard={activeDashboard}
                        patientId={patientId}
                        showLast24h={true}
                    />
                </div>

                {children}
            </div>
        </StyledWrapper>
    );
};

//language=SCSS
const StyledWrapper = styled.div`
& {
    .health-report-widgets-wrapper {
        padding: 30px;
        padding-bottom: 160px;
        width: calc(100% - 250px);
        /*overflow-y: auto;*/
        position: absolute !important;
        left: 250px;
    }
    
    .health-report-header {
        display: flex;
        position: relative;
    }
}
`;

export {HealthReportWrapper};
